/**
 * x402 Protocol Utilities
 * Helper functions for working with x402 protocol
 */

import { SUINetwork } from "./types"

/**
 * Get the base URL for the facilitator service based on environment
 * Production: https://api.x402.buildermare.com
 * Development: http://localhost:3000
 */
export function getFacilitatorBaseUrl(): string {
  const isProduction = process.env.NODE_ENV === 'production'
  return isProduction
    ? 'https://api.x402.buildermare.com'
    : 'http://localhost:3000'
}


/**
 * Maps SUI network to full network string for facilitator service
 */
export function mapSUINetwork(network: SUINetwork): string {
  return `sui:${network}`
}

